import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { ConsultationAnswerComponent } from './consultation-answer/consultation-answer.component';
import { BoolPipe } from './bool.pipe';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ConsultationQuestionComponent } from './consultation-question/consultation-question.component';
import { ConsultationViewerComponent } from './consultation-viewer.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { FilePipe } from './file.pipe';

@NgModule({
  declarations: [
    ConsultationAnswerComponent,
    ConsultationQuestionComponent,
    ConsultationViewerComponent
  ],
  providers: [],
  imports: [
    CommonModule,
    NzFormModule,
    FormsModule,
    NzDescriptionsModule,
    NzCheckboxModule,
    NzRadioModule,
    NzInputModule,
    NzInputNumberModule,
    NzDatePickerModule,
    NzSelectModule,
    BoolPipe,
    FilePipe
  ],
  exports: [ConsultationViewerComponent]
})
export class ConsultationViewerModule {}
